class Hotspots extends HTMLElement {
  constructor() {
    super();

    this.modal = document.querySelector('#modal');
    this.modalDialog = document.querySelector('modal-dialog#hotspot-product-info');
    this.modalOpener = document.querySelector('modal-opener#open-hotspot-product-info button');
    this.closeModalButton = document.querySelector('[id^="ModalClose-"]');
    this.openMethod = null;
    this.openMethods = {
      CLICK: 1,
      HOVER: 2,
    };
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.#addEventListeners();
    this.#fireEvent('hotspot_image', 'view_section', 'Hotspot image');
  }

  #addEventListeners() {
    this.querySelectorAll('.hotspot button').forEach((button) => {
      button.addEventListener('click', (event) => this.#clickHotspot(event, button));

      button.addEventListener('pointerenter', (event) => this.#startHotspotHover(event, button));
    });

    this.modal.addEventListener('pointerleave', (event) => this.#stopHotspotHover(event));

    this.modalDialog.addEventListener('click', () => this.#onCloseModalButton());
  }

  #clickHotspot(event, button) {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    this.openMethod = this.openMethods.CLICK;
    this.#openModal(event, button);

    this.#fireEvent('rtd_hotspot_image', 'view_hotspot', this.product.title);
  }

  #startHotspotHover(event, button) {
    this.hoverTimeout = setTimeout(() => {
      this.openMethod = this.openMethods.HOVER;
      this.#openModal(event, button);

      this.modal.classList.add('open-modal-animation');
      this.#fireEvent('rtd_hotspot_image', 'hover_on_hotspot', this.product.title);
    }, 500);
  }

  #stopHotspotHover(event) {
    if (this.openMethod == this.openMethods.HOVER) {
      this.closeModalButton.click();
    }
  }

  #openModal(event, button) {
    this.#setRelevantProduct(button.dataset.productName);
    this.#updateModalContents(event);
    this.modalOpener.click();
    button.setAttribute('selected', '');
  }

  #onCloseModalButton() {
    this.modal.classList.add('close-modal-animation');
    this.modal.classList.remove('open-modal-animation');
    this.querySelectorAll('.hotspot button').forEach((button) => button.removeAttribute('selected'));
  }

  #updateModalContents(event) {
    const relevantProduct = this.product;

    const modalImage = this.modal.querySelector('img');
    modalImage.src = relevantProduct.media[0].src;
    modalImage.alt = relevantProduct.media[0].alt;

    this.modal.querySelector('a').href = relevantProduct.url;
    this.modal.querySelector('.product-title').textContent = relevantProduct.title;
    this.modal.querySelector('.product-price').textContent = `£${(relevantProduct.price / 100).toFixed(2)}`;
    this.modal.classList.remove('close-modal-animation');

    this.modal.style.marginTop = this.#calculateTopMargin(event.clientY);
    this.modal.style.marginLeft = this.#calculateLeftMargin(event.clientX);
  }

  #calculateLeftMargin(clickPositionX) {
    if (clickPositionX + this.modal.clientWidth > window.innerWidth) {
      this.modal.style.transformOrigin = 'right';
      if (clickPositionX - this.modal.clientWidth > 0) {
        return `${(clickPositionX - this.modal.clientWidth) / 10}rem`;
      }

      return `${(window.innerWidth - this.modal.clientWidth) / 10}rem`;
    }

    this.modal.style.transformOrigin = 'left';
    return `${clickPositionX / 10}rem`;
  }

  #calculateTopMargin(clickPositionY) {
    const topPosition = clickPositionY - this.modal.clientHeight / 2;

    if (topPosition < 0) {
      return '0rem';
    }

    return `${topPosition / 10}rem`;
  }

  #setRelevantProduct(productName) {
    const productInfoNodes = document.querySelectorAll('#hidden-product-info');
    const productInfos = [...productInfoNodes];
    const relevantProductNode = productInfos.find((node) => node.dataset.productName == productName);
    const relevantProduct = JSON.parse(relevantProductNode.textContent);
    const url = relevantProductNode.dataset.productUrl;

    this.product = {
      ...relevantProduct,
      url,
    };
  }

  #fireEvent(eventContext, eventAction, eventValue) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'site_interaction',
      context: eventContext,
      action: eventAction,
      value: eventValue,
    });
  }
}

if (!customElements.get('hotspots-image')) {
  window.customElements.define('hotspots-image', Hotspots);
}
